module.exports = __webpack_public_path__ + "5bee74caefdf9d0a834915f6c8eeb259.svg";


//////////////////
// WEBPACK FOOTER
// /~/react-notifications/lib/fonts/notification.svg?s3g3t9
// module id = 889
// module chunks = 29